import type { Theme as NavTheme } from '@react-navigation/native';
import type { ThemePalette } from './types';

export function createNavigationTheme(colors: ThemePalette, isDark: boolean): NavTheme {
  return {
    dark: isDark,
    colors: {
      primary: colors.primary,
      background: colors.bgSecondary,
      card: colors.background,
      text: colors.textPrimary,
      border: colors.border,
      notification: colors.error,
    },
    fonts: {
      regular: { fontFamily: 'System', fontWeight: '400' },
      medium: { fontFamily: 'System', fontWeight: '500' },
      bold: { fontFamily: 'System', fontWeight: '700' },
      heavy: { fontFamily: 'System', fontWeight: '800' },
    },
  };
}
